import React from 'react';
import ModernLinkList from '../components/links/ModernLinkList';

function Links() {
  return <ModernLinkList />;
}

export default Links;